export default __webpack_public_path__ + "static/media/JAM.719e22a7.svg";